<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th>{{ i18n._102_USER_NAME | translate }}</th>
                <th>{{ i18n._756_PREVIOUS_SCORECARD | translate }}</th>
                <th>{{ i18n._757_PREVIOUS_CLASS_ | translate }}</th>
                <th>{{ i18n._758_CURRENT_SCORECARD | translate }}</th>
                <th>{{ i18n._759_CURRENT_CLASS | translate }}</th>
                <th>{{ i18n._760___MOVEMENT | translate }}</th>
                <th>{{ i18n._761_MOVEMENT_CLASS | translate }}</th>
                <th>{{ i18n._762_POINTS | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td>{{ i.username }}</td>
                <td>
                    <button
                        type="button"
                        class="cmps-btn-table"
                        (click)="showScorecard(i, i.previous)"
                    >
                        {{ i.previous.points | number: '1.0-2' }}
                    </button>
                </td>
                <td>{{ i.previous.class_ }}</td>
                <td>
                    <button
                        type="button"
                        class="cmps-btn-table"
                        (click)="showScorecard(i, i.current)"
                    >
                        {{ i.current.points | number: '1.0-2' }}
                    </button>
                </td>
                <td>{{ i.current.class_ }}</td>
                <td>{{ i.movement.points | number: '1.0-2' }}</td>
                <td>{{ i.movement.class_ }}</td>
                <td>{{ i.points | number: '1.0-2' }}</td>
            </tr>
        </tbody>
        <tfoot class="tfoot-light">
            <tr>
                <th>{{ i18n._743_SUMMARY | translate }}</th>
                <th>{{ data.overall.previous.points | number: '1.0-2' }}</th>
                <th></th>
                <th>{{ data.overall.current.points | number: '1.0-2' }}</th>
                <th></th>
                <th>{{ data.overall.movement.points | number: '1.0-2' }}</th>
                <th></th>
                <th>{{ data.overall.points | number: '1.0-2' }}</th>
            </tr>
        </tfoot>
    </table>
</div>
